import { ORG_ENVIRONMENT, type OrgEnvironment } from "@/server/types/org";

/**
 * Health systems put in front of a workspace that has suggested none of its own,
 * keyed by environment so a sandbox never sees a live endpoint. Each entry is a
 * name prefix rather than an id, because the canonical row can be re-keyed while
 * the name stays stable, and a term matching nothing is skipped. Sandbox terms
 * are full seeded names, so a bare vendor prefix cannot pull in a stray clinic.
 */
export const SUGGESTED_SOURCE_TERMS: Record<OrgEnvironment, readonly string[]> = {
  [ORG_ENVIRONMENT.PRODUCTION]: ["Aetna", "Boston Children's Hospital", "Medicare"],
  // Every sandbox source that exists, so a sandbox workspace has something to
  // click. "Aetna Sandbox" was listed here and has never existed, which left one
  // suggestion on screen once Epic had been added.
  [ORG_ENVIRONMENT.SANDBOX]: [
    "Athena Sandbox",
    "Cerner Sandbox",
    "eClinicalWorks Sandbox",
    "Epic Sandbox",
    "Medicare Sandbox",
  ],
};

/**
 * How many suggestions of their own a patient needs before the popular choices
 * stop being offered. The longest term list, so no environment can offer fewer
 * defaults than the threshold that hides them.
 */
export const SUGGESTED_SOURCE_TARGET = Math.max(
  ...Object.values(SUGGESTED_SOURCE_TERMS).map((terms) => terms.length),
);
